"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingChoices = exports.VariationD = exports.VariationC = exports.VariationB = exports.VariationA = exports.Variations = void 0;
exports.getVariations = getVariations;
exports.getVariationsFrom = getVariationsFrom;
exports.getVariationA = getVariationA;
exports.getVariationAFrom = getVariationAFrom;
exports.getVariationB = getVariationB;
exports.getVariationBFrom = getVariationBFrom;
exports.getVariationC = getVariationC;
exports.getVariationCFrom = getVariationCFrom;
exports.getVariationD = getVariationD;
exports.getVariationDFrom = getVariationDFrom;
exports.getRatingChoices = getRatingChoices;
exports.getRatingChoicesFrom = getRatingChoicesFrom;
var Variations;
(function (Variations) {
    Variations["A"] = "Variation A";
    Variations["B"] = "Variation B";
    Variations["C"] = "Variation C";
    Variations["D"] = "Variation D";
})(Variations || (exports.Variations = Variations = {}));
function getVariations() {
    return [Variations.A, Variations.B, Variations.C, Variations.D];
}
function getVariationsFrom(value) {
    return getVariations().find(function (type) { return type === value; });
}
var VariationA;
(function (VariationA) {
    VariationA["_1"] = "Structure";
    VariationA["_2"] = "Development";
    VariationA["_3"] = "Conventions";
})(VariationA || (exports.VariationA = VariationA = {}));
function getVariationA() {
    return [VariationA._1, VariationA._2, VariationA._3];
}
function getVariationAFrom(value) {
    return getVariationA().find(function (type) { return type === value; });
}
var VariationB;
(function (VariationB) {
    VariationB["_1"] = "Structure";
    VariationB["_2"] = "Conventions";
})(VariationB || (exports.VariationB = VariationB = {}));
function getVariationB() {
    return [VariationB._1, VariationB._2];
}
function getVariationBFrom(value) {
    return getVariationB().find(function (type) { return type === value; });
}
var VariationC;
(function (VariationC) {
    VariationC["_1"] = "Structure";
    VariationC["_2"] = "Development";
    VariationC["_3"] = "Style";
    VariationC["_4"] = "Conventions";
})(VariationC || (exports.VariationC = VariationC = {}));
function getVariationC() {
    return [VariationC._1, VariationC._2, VariationC._3, VariationC._4];
}
function getVariationCFrom(value) {
    return getVariationC().find(function (type) { return type === value; });
}
var VariationD;
(function (VariationD) {
    VariationD["_1"] = "Structure";
    VariationD["_2"] = "Development";
    VariationD["_3"] = "Style";
    VariationD["_4"] = "Conventions";
    VariationD["_5"] = "Process";
    VariationD["_6"] = "Listening";
})(VariationD || (exports.VariationD = VariationD = {}));
function getVariationD() {
    return [VariationD._1, VariationD._2, VariationD._3, VariationD._4, VariationD._5, VariationD._6];
}
function getVariationDFrom(value) {
    return getVariationD().find(function (type) { return type === value; });
}
var RatingChoices;
(function (RatingChoices) {
    RatingChoices["_1"] = "EE";
    RatingChoices["_2"] = "ME";
    RatingChoices["_3"] = "PME";
    RatingChoices["_4"] = "DNME";
})(RatingChoices || (exports.RatingChoices = RatingChoices = {}));
function getRatingChoices() {
    return [RatingChoices._1, RatingChoices._2, RatingChoices._3, RatingChoices._4];
}
function getRatingChoicesFrom(value) {
    return getRatingChoices().find(function (type) { return type === value; });
}
